module.exports = __webpack_public_path__ + "img/cspace-onlinesupport.a59e5b47.svg";